module.exports = __webpack_public_path__ + "img/element_4.4abaa9d2.png";